module.exports = __webpack_public_path__ + "img/GB.ae6cc02c.svg";